var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('p',{staticClass:"text"},[_vm._v("Last Time Updated: "+_vm._s(_vm.showDate))])])}
var staticRenderFns = []

export { render, staticRenderFns }